module.exports = __webpack_public_path__ + "media/images/flags/PH-d772b29ca3de9461b49fd0e1512c93d6.svg";